import { make } from 'vuex-pathify';

const moduleState = {
    event: {}
};

export default {
    namespaced: true,
    state: moduleState,
    mutations: {
        ...make.mutations(moduleState)
    }
};
